import {Component} from '@angular/core';

@Component({
  selector: 'app-header-text',
  templateUrl: './header-text.component.html',
  styleUrls: ['./header-text.component.scss'],
  standalone: false
})

export class HeaderTextComponent {}
